/**
 * The dimension targeted by a question
 * Shared F/E and Api Enum
*/
export enum ViDimensionEnum {
    brandIdentity = 'BrandIdentity',
    productsAndServices = 'ProductsAndServices',
    customerExperience = 'CustomerExperience',
    topicalAuthority = 'TopicalAuthority',
    misinformationRisk = 'MisinformationRisk',
    competitivePositioning = 'CompetitivePositioning',
}
